/* 
    Here the function name is the same as of the actionType name but in lower case
*/

import jwt from "jsonwebtoken";
import apiCall from "../util/apicall";
import { authChecker } from "../util/authChecker";
import {
  googleAuth,
  googleAuthError,
  googleAuthFalse,
  googleAuthTrue,
  createPostError,
  createPostSuccess,
  getPostSuccess,
  getPostError,
  getTagsSuccess,
  getTagsError,
  clearPostSuccessError,
  singleArticleSuccess,
  singleArticleError,
  singleArticleCommentsSuccess,
  singleArticleCommentsError,
  submitCommentSuccess,
  submitCommentError,
  getCurrentUserSuccess,
  getCurrentUserError,
  likeArticleSuccess,
  likeArticleError,
  dislikeArticleSuccess,
  dislikeArticleError,
  followUserSuccess,
  followUserError,
  unfollowUserSuccess,
  unfollowUserError,
  deleteCommentSuccess,
  deleteCommentError,
  deleteCommentReset,
  userFeedSuccess,
  userFeedError,
  userUpdateSuccess,
  userUpdateError,
  userUpdateReset,
  userLogout,
  getPostAuthorSuccess,
  getPostAuthorError,
  userPostsSuccess,
  userPostsError,
  tagPostsSuccess,
  tagPostsError
} from "./actionDispatchers";

export const google_auth = (url, body, type) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      localStorage.setItem("jwt", res.data.token);
      localStorage.setItem("user", res.data.user);
      dispatch(googleAuth(res));
      dispatch(googleAuthTrue());
      dispatch(googleAuthError({}));
    })
    .catch((err) => {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      dispatch(googleAuth({}));
      dispatch(googleAuthFalse());
      dispatch(googleAuthError(err));
    });
};

// This action/function will help when the user token is deleted from localstorage. It will be relevant when the token saved in localstorage is valid.

// export const user_from_token = (url, body, type) => dispatch => {
//   apiCall(type, url, body && body).then(res => {
//     dispatch(userFromToken(res));
//   }).catch(err => {
//     dispatch(userFromTokenError(err));
//   })
// }

export const return_google_auth = (token) => (dispatch) => {
  if (token) {
    const auth = authChecker(token);
    if (!authChecker(token)) {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      dispatch(googleAuthFalse());
    } else dispatch(googleAuthTrue());
  } else {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    dispatch(googleAuthFalse());
  }
};

export const get_articles = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(getPostSuccess(res));
    })
    .catch((err) => {
      dispatch(getPostError(err));
    });
};

export const get_tags = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(getTagsSuccess(res));
    })
    .catch((err) => {
      dispatch(getTagsError(err));
    });
};

export const post_article = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(createPostSuccess(res));
    })
    .catch((err) => {
      dispatch(createPostError(err));
    });
};

export const get_single_article = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(singleArticleSuccess(res));
    })
    .catch((err) => {
      dispatch(singleArticleError(err));
    });
};

export const get_single_article_comments = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(singleArticleCommentsSuccess(res));
    })
    .catch((err) => {
      dispatch(singleArticleCommentsError(err));
    });
};

export const submit_comment = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(submitCommentSuccess(res));
    })
    .catch((err) => {
      dispatch(submitCommentError(err));
    });
};

export const delete_comment = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(deleteCommentSuccess(res));
    })
    .catch((err) => {
      dispatch(deleteCommentError(err));
    });
};

export const delete_comment_reset = () => (dispatch) => {
  dispatch(deleteCommentReset());
};

export const user_feed = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(userFeedSuccess(res));
    })
    .catch((err) => {
      dispatch(userFeedError(err));
    });
};

export const get_current_user = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(getCurrentUserSuccess(res));
    })
    .catch((err) => {
      dispatch(getCurrentUserError(err));
    });
};

export const get_post_Author = (type, url, body) => dispatch => {
  apiCall(type, url, body && body).then(res => {
    dispatch(getPostAuthorSuccess(res));
  }).catch(err => {
    dispatch(getPostAuthorError(err));
  })
}

export const like_article = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(likeArticleSuccess(res));
    })
    .catch((err) => {
      dispatch(likeArticleError(err));
    });
};

export const user_update = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(getCurrentUserSuccess(res))
      dispatch(userUpdateSuccess(res));
    })
    .catch((err) => {
      dispatch(userUpdateError(err));
    });
};

export const user_logout = () => dispatch => {
  localStorage.removeItem("jwt");
  localStorage.removeItem("user");
  dispatch(userLogout());
}

export const user_update_reset = () => (dispatch) => {
  dispatch(userUpdateReset());
};

export const user_posts = (type, url, body) => dispatch => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(userPostsSuccess(res));
    })
    .catch((err) => {
      dispatch(userPostsError(err));
    });
}

export const tag_posts = (type, url, body) => dispatch => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(tagPostsSuccess(res));
    })
    .catch((err) => {
      dispatch(tagPostsError(err));
    });
}

export const follow_user = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(followUserSuccess(res));
    })
    .catch((err) => {
      dispatch(followUserError(err));
    });
};

export const unfollow_user = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(unfollowUserSuccess(res));
    })
    .catch((err) => {
      dispatch(unfollowUserError(err));
    });
};

export const follow_user_reset_status = () => (dispatch) => {
  dispatch(unfollowUserError());
};

export const like_article_reset_status = () => (dispatch) => {
  dispatch(likeArticleError());
};

export const dislike_article = (type, url, body) => (dispatch) => {
  apiCall(type, url, body && body)
    .then((res) => {
      dispatch(dislikeArticleSuccess(res));
    })
    .catch((err) => {
      dispatch(dislikeArticleError(err));
    });
};

export const submit_comment_reset_status = () => (dispatch) => {
  dispatch(submitCommentError());
};

export const clear_post_success_error = () => (dispatch) => {
  dispatch(clearPostSuccessError());
};

//Not used frequently

export const set_auth_true = () => (dispatch) => {
  dispatch(googleAuthTrue());
};

export const set_auth_false = () => (dispatch) => {
  dispatch(googleAuthFalse());
};
